import { EVENTS } from '@decathlon/shared';
import { clear, h } from '../dom.js';
import { affiliatePanel } from './affiliate.js';

export const APP_VERSION = __APP_VERSION__;

export function renderAbout(root: HTMLElement, onBack: () => void): void {
  clear(root);
  root.append(
    h(
      'div',
      { class: 'center' },
      h(
        'div',
        { class: 'panel wide stack' },
        h(
          'div',
          { class: 'row', style: 'justify-content:space-between' },
          h('h1', {}, 'ℹ️ About Deca', h('span', { class: 'accent' }, 'thlon')),
          h('button', { class: 'btn small ghost', onclick: onBack }, '← Back'),
        ),
        h(
          'p',
          {},
          'A 3D decathlon in the spirit of Daley Thompson’s Decathlon (1984). You hammer two keys alternately to run, hold and release Space to set jump and throw angles, and fight through ten events over two days. Lose a life each time you miss a qualifying standard; finish the 800m and the standards get harder.',
        ),
        h(
          'ul',
          { class: 'about-list' },
          h('li', {}, h('b', {}, 'Events: '), EVENTS.map((e) => e.name).join(', ') + '.'),
          h(
            'li',
            {},
            h('b', {}, 'Scoring: '),
            'the real IAAF combined-events tables, so your total compares to real athletes. Daley Thompson’s 1984 gold re-scores to 8847.',
          ),
          h(
            'li',
            {},
            h('b', {}, 'Running: '),
            'speed follows how fast you alternate the two run keys. Same key twice does nothing. About 10 presses a second is the sweet spot; the 400m and 800m add a stamina bar.',
          ),
          h(
            'li',
            {},
            h('b', {}, 'Jumps: '),
            'hold Space on the run-up to sweep the angle gauge and release to take off. Long jump wants about 25° just before the board; high jump about 55° from two or three metres out.',
          ),
          h(
            'li',
            {},
            h('b', {}, 'Accounts: '),
            'play as a guest and your results stay in this browser, or create an account to keep progress graphs across devices.',
          ),
          h(
            'li',
            {},
            h('b', {}, 'Cameras and sound: '),
            'side, behind and TV cameras (camera button), a generated crowd that roars with you, a stadium announcer and chiptune music. No audio or model files: everything is built in your browser.',
          ),
        ),
        affiliatePanel(),
        h(
          'div',
          { class: 'row', style: 'justify-content:space-between' },
          h('span', { class: 'muted small' }, `Version ${APP_VERSION}`),
          h('span', { class: 'muted small' }, 'Built with Three.js, TypeScript and Vite.'),
        ),
      ),
    ),
  );
}
